import { Injectable } from '@angular/core';

import { InsuranceCms } from '@interfaces/directus-cms.interface';

import { Observable, of } from 'rxjs';

import { insuranceCmsMock } from '../mocks-handler/mocks/directus-cms.mock';

@Injectable({
    providedIn: 'root',
})
export class DirectUsRepository {
    /**
     * Get content data from directUS
     * @returns Return content data from directUS
     * Use
     */
    public getInsuranceData(): Observable<InsuranceCms> {
        return of(insuranceCmsMock);
    }
}
